import { render } from "./TotemAdm.vue?vue&type=template&id=3c806550&ts=true"
import script from "./TotemAdm.vue?vue&type=script&lang=ts"
export * from "./TotemAdm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__